import { render, staticRenderFns } from "./AnalysisAvatars.vue?vue&type=template&id=406044c6&scoped=true&"
import script from "./AnalysisAvatars.vue?vue&type=script&lang=js&"
export * from "./AnalysisAvatars.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisAvatars.vue?vue&type=style&index=0&id=406044c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406044c6",
  null
  
)

export default component.exports